
export default class StringProcessingService{
    StringFormatUrl(str){
        if(str!==undefined&&str!==null){
            var pattern = new RegExp("[^a-zA-Z0-9]+", "g");
            return(str.toLowerCase().replace(pattern,'-'))
        }
        return null;
    }
}